import React from "react";

export function Card({ children, className = "", ...props }) {
  return (
    <div
      className={`bg-white rounded-2xl shadow-md p-6 ${className}`}
      {...props}
    >
      {children}
    </div>
  );
}